import { TieOutPage } from '@/pages/shared/tie-out';

export function TravelTieOutPage() {
  return <TieOutPage app="TRAVEL" />;
}
